export const SOCKET_EVENTS = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    ERROR: 'error',
    RECONNECT_ATTEMPT: 'reconnect_attempt',
    RECONNECT_FAILED: 'reconnect_failed',
    EVENT_JOIN_FLEETS: 'event_join_fleets',
    ORDER_UPDATES: 'fleet_order_updates',
};

export const SOCKET_ACTIONS = {
    NEW_ORDERS: 'NEW_ORDERS',
};
